import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close2--sprite",
  "use": "close2--sprite-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close2--sprite\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.3337 2.54699L17.4537 0.666992L10.0003 8.12033L2.54699 0.666992L0.666992 2.54699L8.12033 10.0003L0.666992 17.4537L2.54699 19.3337L10.0003 11.8803L17.4537 19.3337L19.3337 17.4537L11.8803 10.0003L19.3337 2.54699Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol